import * as yup from "yup";

import {
  CommonConstants,
  LabelConstants,
  BookingTemplateConstants,
} from "@assets/constants";

import { multipleEmailSchema } from "./common";

export const routeValidationSchema = yup.object({
  BookingTemplateName: yup.string().trim().required(),
});

export const partnerValidationSchema = yup.object({
  CityPort: yup
    .object()
    .nullable()
    .when("PartnerFillOutType", {
      is: BookingTemplateConstants.PARTNER_FILL_OUT_TYPE.NEW,
      then: (schema) =>
        schema.required().typeError(LabelConstants.ERROR_LABELS.REQUIRED_FIELD),
    }),
  Phone: yup.string().matches(CommonConstants.PHONE_NO_REGEX, {
    message: LabelConstants.ERROR_LABELS.INVALID_PHONE,
    excludeEmptyString: true,
  }),
  Email: multipleEmailSchema,
  PartnerCompany: yup
    .object()
    .nullable()
    .when("PartnerFillOutType", {
      is: BookingTemplateConstants.PARTNER_FILL_OUT_TYPE.PREVIOUS,
      then: (schema) =>
        schema.required().typeError(LabelConstants.ERROR_LABELS.REQUIRED_FIELD),
    }),
});

export const transportRequestValidationSchema = yup.object({
  CompanyName: yup.string().required(),
  Phone: yup.string().matches(CommonConstants.PHONE_NO_REGEX, {
    message: LabelConstants.ERROR_LABELS.INVALID_PHONE,
    excludeEmptyString: true,
  }),
  Email: multipleEmailSchema,
});
